/*
  eslint-disable no-underscore-dangle, no-useless-escape
*/
import angular from 'angular';
import moment from 'moment';

const formatDateTime = (date) => moment.utc(date).format('YYYY-MM-DD HH:mm:ss');

angular.module('myConsultApp').directive('inputDatetimepicker', (utilitiesV2) => {
  return {
    templateUrl: 'templates/v2/input-datetimepicker.html',
    restrict: 'E',
    scope: {
      name: '@',
      scrollContainer: '@',
      initialVal: '=',
      isDisabled: '=',
      allowFuture: '=',
      format: '@',
      placeholder: '@',
      field: '@',
      elementId: '@',
      startDate: '@',
      endDate: '@',
      onChange: '&',
    },
    link: ($scope, element) => {
      $scope.isInvalid = false;
      $scope.additionalErrors = [];
      const currentDateTime = moment.utc();
      $scope.month = currentDateTime.format('MM');
      $scope.day = currentDateTime.format('DD')
      $scope.year = currentDateTime.format('YYYY')
      $scope.hour = currentDateTime.format('HH')
      $scope.minute = currentDateTime.format('mm')

      $scope.validate = () => {
        $scope.isInvalid = false;
        $scope.additionalErrors = [];

        if ($scope.selectedDate) {
          const selectedDate = moment($scope.selectedDate);

          if (!selectedDate.isValid()) {
            $scope.isInvalid = true;
          } else {
            $scope.selectedDate = selectedDate.format($scope.format);

            if ($scope.allowFuture === false) {
              let today = moment();
              let offsetTimezone = today.utcOffset();
              if(offsetTimezone < 0){
                today = today.add(Math.abs(offsetTimezone), "minutes");
              } else {
                today = today.subtract(offsetTimezone, "minutes");
              }
              $scope.isInvalid = selectedDate > today;
            } else {
              const startDate = $scope.startDate ? moment($scope.startDate) : null;
              const endDate = $scope.endDate ? moment($scope.endDate) : null;

              if (startDate || endDate) {
                if (endDate && selectedDate > endDate) {
                  $scope.isInvalid = true;
                  $scope.additionalErrors.push(
                    `${$scope.field} must be before ${formatDateTime(endDate)}`,
                  );
                }

                if (startDate && selectedDate < startDate) {
                  $scope.isInvalid = true;
                  $scope.additionalErrors.push(
                    `${$scope.field} must be after ${formatDateTime(startDate)}`,
                  );
                }
              }
            }
          }
        }

        $scope.onChange({ val: $scope.selectedDate });
      };

      $scope.$watch('selectedDate', () => {
        $scope.validate();
      });

      $scope.$watch('startDate', () => {
        $scope.validate();
      });

      $scope.$watch('endDate', () => {
        $scope.validate();
      });

      $scope.$watch('initialVal', () => {
        $scope.selectedDate = $scope.initialVal || '';
        $scope.validate();
      });

      utilitiesV2.bindAbsoluteElementToScrollContainer(
        angular.element($scope.scrollContainer),
        element[0],
        '.angularjs-datetime-picker',
        true,
      );
    },
  };
});
